<template>
  <div class="layout-px-spacing">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:;">{{ $t('Master Data') }}</a></li>
                <li class="breadcrumb-item active" aria-current="page"><span>{{ $t('District') }}</span></li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12">
        <div class="d-flex align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-arrow-left" data-v-02c2cbc4="">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <router-link class="text-primary" tag="a" :to="{ name: 'DistrictList' }">{{ $t('Back') }}</router-link>
        </div>
      </div>
    </div>
    <div class="row layout-top-spacing">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
        <div class="panel br-4">
          <div class="panel-body">
            <form @submit.prevent="actionForm">
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="name">{{ $t('District') }}</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" v-model="formData.name"
                    :class="[hasFormError.name ? (hasFormError.name ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('District')"
                    @blur="districtStore.removeErrorFormSingle('name')" />
                  <div v-if="hasFormError.name" class="invalid-feedback">{{ hasFormError.name }}</div>
                </div>
              </div>
              <div class="row">
                <template v-if="hasErrorSingle">
                  <div class="col-12">
                    <div class="alert alert-light-danger alert-dismissible border-0 mb-4" role="alert">
                      <strong>{{ $t('Failed') }}</strong> {{ hasErrorSingle }}
                      <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">×</button>
                    </div>
                  </div>
                </template>
                <div class="col-12 col-md-4 offset-md-8">
                  <template v-if="action == 'view'">
                  </template>
                  <template v-else>
                    <button type="submit" class="btn btn-primary btn-lg" :disabled="isLoadingForm">
                      <span v-if="isLoadingForm" class="spinner-border text-white me-2 align-self-center loader-sm">
                        Loading...
                      </span>
                      {{ $t('Save') }}
                    </button>
                    &nbsp;
                    <button @click="districtStore.resetForm" type="button" class="btn btn-danger btn-lg">
                      {{ $t('Cancel') }}
                    </button>
                  </template>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useDistrictStore } from '@/store/master-data/districtStore';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const districtStore = useDistrictStore();
const { formData, hasFormError, isLoadingForm, hasErrorSingle, isSuccess } = storeToRefs(districtStore);
const route = useRoute();
const router = useRouter()
districtStore.resetForm();

const idData = ref('');
const action = ref(route.query.act);
const listAction = ['edit', 'view'];
if (listAction.includes(route.query.act)) {
  idData.value = route.query.id;
  districtStore.getDataDetail(idData.value);
}

const actionForm = async () => {
  if (action.value == 'edit') {
    await districtStore.updateData(idData.value);
    if (isSuccess.value) {
      new window.Swal({
        icon: 'success',
        title: t('Success'),
        padding: '2em',
      });
      router.push({ name: 'DistrictList' });
    }
  } else if (action.value == 'view') {
    // console.log('view');
  } else {
    await districtStore.saveData();
    if (isSuccess.value) {
      new window.Swal({
        icon: 'success',
        title: t('Success'),
        padding: '2em',
      });
    }
  }
}
</script>
